/* ─────────────────────────────────────────────────────────────────────────────
   ФИЛЬТРЫ ВИТРИНЫ — одно состояние на всё приложение.

   Раньше фильтры жили внутри страницы: два выпадающих списка в шапке, которые
   сбрасывались при переходе в раздел и ничего не знали друг о друге. Теперь
   поиск, цена и сортировка лежат в сторах, ими управляет рельс слева, а
   страницы только читают результат.
   ───────────────────────────────────────────────────────────────────────────── */
import { writable } from 'svelte/store'

export const query    = writable("");     // строка поиска
export const sortBy   = writable("fresh"); // fresh | cheap | rich | ending

/* границы цены игрок задаёт сам: null = граница не указана. Готовые
   диапазоны («до $1 млн» и прочие) убраны — у каждого свои представления
   о дорогом, а имущество на сервере стоит от тысячи до десятков миллионов */
export const priceFrom = writable(null);
export const priceTo   = writable(null);
export const subType  = writable(null);    // тип дома/бизнеса/предмета — из старых конфигов

/* открыта ли карточка лота: пока игрок читает лот, строки поиска и фильтров
   в шапке прячутся — они относятся к списку, а не к конкретному объявлению */
export const lotOpen  = writable(false);

export const SORTS = [
    { id: "fresh",  name: "Свежие"    },
    { id: "cheap",  name: "Дешевле"   },
    { id: "rich",   name: "Дороже"    },
    { id: "ending", name: "Скоро конец" },
];

/* из «$1 200 000», «1200000» и «1 200 000$» одинаково получаем число */
export const toNumber = (value) => {
    const digits = String (value == null ? "" : value).replace (/[^\d]/g, "");
    return digits ? Number (digits) : null;
};

export const priceOf = (item) => Number (
    item && item.hasOwnProperty ("currentBet") ? item.currentBet
    : item && item.minPrice ? item.minPrice
    : (item && item.cost) || 0
);

/* «гос. цена» — сколько имущество стоит у государства. Сравнение с ней и есть
   главный ответ на вопрос «это дорого или нет», поэтому считаем его один раз
   здесь и показываем на каждой табличке. */
export const govPrice = (item) => Number ((item && item.params && item.params.cost) || 0);

export const govDiff = (item) => {
    const gov = govPrice (item), price = priceOf (item);
    if (!gov || !price) return null;
    return Math.round (((price - gov) / gov) * 100);
};

export const matchQuery = (item, text, name) => {
    const q = String (text || "").trim ().toLowerCase ();
    if (!q) return true;
    if (q[0] === "№" || q[0] === "#") return String (item.id) === q.slice (1).trim ();

    const area = item.params && (item.params.area || item.params.motorShow || item.params.numberPlate);
    return [name, area, item.author && item.author.name, "№" + item.id]
        .some ((v) => String (v || "").toLowerCase ().includes (q));
};

export const applyFilters = (items, opts) => {
    const { text, min, max, sort, nameOf } = opts;

    let list = items.filter ((item) => {
        const value = priceOf (item);
        if (min != null && value < min) return false;
        if (max != null && value > max) return false;
        return matchQuery (item, text, nameOf ? nameOf (item) : "");
    });

    switch (sort) {
        case "cheap":  return list.sort ((a, b) => priceOf (a) - priceOf (b));
        case "rich":   return list.sort ((a, b) => priceOf (b) - priceOf (a));
        case "ending": return list.sort ((a, b) => new Date (a.endDate) - new Date (b.endDate));
        default:       return list.sort ((a, b) => (b.id || 0) - (a.id || 0));
    }
};
